// extracted by mini-css-extract-plugin
export default {"container":"Waa-z","heading":"Xaa-z","links":"Yaa-z","linkBtn":"Zaa-z","disabled":"_aa-z","linkUppercaseBold":"aba-z","copy":"bba-z","subCopy":"cba-z"};